// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-page[data-v-47ade9bc]{display:flex;font-family:\"Lettera Text LL\",Helvetica,Arial,sans-serif;justify-content:center;padding:24px 15px 40px}@media print,screen and (min-width:769px){.login-page[data-v-47ade9bc]{padding:48px 20px 64px}}.login-page-container[data-v-47ade9bc]{max-width:460px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
